import DataTable, {Order} from "datatables.net-bs5";

export default class {
    static init = () => {
        maps();
    }
}

function maps() {
    let table = document.querySelector('.datatable[data-table="eo_maps"]') as HTMLElement;
    if(!table) {
        return;
    }

    let datatable = new DataTable('.datatable[data-table="eo_maps"]',{
        pageLength: 20,
        lengthMenu: [10,20,50,100],
        processing: true,
        serverSide: true,
        responsive: true,
        ajax: {
            url: '?do=getMaps',
            data: function(data) {
                return data;
            }
        },
        columns: [
            { data: 'id', className: "align-middle" },
            { data: null, className: "align-middle", render: function(data) {
                    return `<a href="/eo/maps/${data.id}">${data.name}</a>`;
                }},
            { data: null, className: "align-middle", render: function(data : any) {
                    return `${data.width}x${data.height}`;
                }},
            { data: 'warp_count', className: "align-middle" },
            { data: 'mob_count', className: "align-middle" },
        ],
        order: [[0,"asc"]] as Order[]
    });
}
